import { render, staticRenderFns } from "./TermsWidget.vue?vue&type=template&id=49f8751f&scoped=true&"
import script from "./TermsWidget.vue?vue&type=script&lang=js&"
export * from "./TermsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TermsWidget.vue?vue&type=style&index=0&id=49f8751f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f8751f",
  null
  
)

export default component.exports